// Login
export const LOGIN_URL = '/login';

// Settings
export const SETTINGS_URL = '/settings';

// Devices
export const DASHBOARD_URL = '/devices';
export const EDIT_DEVICE_URL = '/devices/edit/:id';
export const NEW_DEVICE_URL = '/devices/new';
export const DEVICE_DETAILS_URL = '/devices/details/:id';
export const DEVICES_CALENDAR_URL = '/devices/calendar';

// Moves
export const MOVES_URL = '/moves';
export const MOVES_CALENDAR_URL = '/moves/calendar';